import { lazy } from 'react';
import type { Routes } from '@/@types/routes';
import { SIGN_IN } from '@/constants/route.constant.ts';

const authRoute: Routes = [
  {
    key: 'signIn',
    path: SIGN_IN,
    component: lazy(() => import('@/views/auth/SignIn')),
    authority: [],
  },
];

export default authRoute;
